import React from 'react';

export default function FormField({ label, id, children }) {
  return (
    <div className='data-edit mb-3'>
      <dl className='data-edit__grad_thesis_wrap'>
        <dt className='data-edit__grad_thesis_title'>
          <label htmlFor={id}>{label}</label>
        </dt>

        <dd className='data-edit__grad_thesis_item'>
          {children}
        </dd>
      </dl>
    </div>
  );
}
